import { AppType, Country, CustomerType, DisabledType, GiveawayProductType, GiveawayType, IdCardCustomerType, IdCardType } from './Enums';
import { CardPaymentModel } from './RegisterModel';
import { CustomerCardModel } from './CardModel';
import { CustomerPreregisterGiviModel } from './CustomerPreregisterGiviModel';

export class CustomerModel {

    public constructor(init?: Partial<Pick<CustomerModel, keyof CustomerModel>>) {

        if (init) {
            if (typeof init.birthDate === 'string') {
                init.birthDate = new Date(init.birthDate);
            }
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.phoneVerifiedAt === 'string') {
                init.phoneVerifiedAt = new Date(init.phoneVerifiedAt);
            }
            if (typeof init.earlyExpirationPointsAt === 'string') {
                init.earlyExpirationPointsAt = new Date(init.earlyExpirationPointsAt);
            }
            if (typeof init.lateExpirationPointsAt === 'string') {
                init.lateExpirationPointsAt = new Date(init.lateExpirationPointsAt);
            }
            if (init.billingInfo) {
                init.billingInfo = new CustomerBillingInfoModel(init.billingInfo);
            }
            if (init.availablePoints < 0) {
                init.availablePoints = init.availablePoints;
            }
            if (init.cards && init.cards.length) {
                init.cards = init.cards.map(item => new CustomerCardModel(item));
            }
            Object.assign(this, init);
        }
    }

    id: number;

    idCard: string;
    idCardType = IdCardCustomerType.Nacional;
    name = '';
    lastName = '';

    email: string;
    emailVerifiedAt: Date;

    phoneCountry: string;
    phone: string;
    phoneVerifiedAt: Date;

    birthDate: Date;

    province = 0;
    canton = 0;
    district = 0;
    address: string;

    isStoreCustomer = false;
    isActive: boolean;
    disabledType: DisabledType;

    type = CustomerType.GiviUser;

    createdAt: Date;

    logoURL = '';


    billingInfo: CustomerBillingInfoModel;


    earlyExpirationPoints = 0; // calculado en DB
    lateExpirationPoints = 0; // calculado en DB
    availablePoints = 0; // calculado en DB

    earlyExpirationPointsAt: Date; // current year
    lateExpirationPointsAt: Date; // next year


    cards: CustomerCardModel[];

    preregisterGivis: CustomerPreregisterGiviModel[];

    // Se utiliza para verificar si el usuario esta ligado a la comunidad
    communityId?: number;
    scratchId?: number;

    approvedAt?: Date;

    rejectedAt?: Date;

    country = Country.CR ;

    get fullname(): string {

        return `${this.name} ${this.lastName}`.trim();
    }

    get isDifferentExpiration(): boolean {

        if (this.earlyExpirationPointsAt && this.lateExpirationPointsAt) {
            if (this.earlyExpirationPointsAt.getFullYear() != this.lateExpirationPointsAt.getFullYear()) {
                return true;
            }
        }
        return false;
    }
}

export class CustomerBillingInfoModel {

    public constructor(init?: Partial<Pick<CustomerBillingInfoModel, keyof CustomerBillingInfoModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    customerId: number;

    idCard: string;
    idCardType: IdCardType = IdCardType.Fisica;

    name = '';
    lastName = '';
    email: string;

    phone: string;

    province = 0;
    canton = 0;
    district = 0;
    address: string;

    createdAt: Date;


    get isValid(): boolean {

        if (this.name && this.idCard && this.email && this.phone) {
            return true;
        }

        return false;
    }

}

export class CustomerWithoutRegisterModel {

    public constructor(init?: Partial<Pick<CustomerWithoutRegisterModel, keyof CustomerWithoutRegisterModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    name: string = '';
    lastName: string = '';
    email: string = '';
    idCard: string = '';
    phone: string = '';
    phoneCountry: string = '';
    transactionType: string; // Givi pop - Ticket - Product
    vendorName: string;
    cardPayment: CardPaymentModel;
    country = Country.CR;
}

export class CustomerPhoneFindModel extends CustomerModel {

    public constructor(init?: Partial<CustomerPhoneFindModel>) {
        super(init);
        if (init) {
            if (typeof init.approvedAt === 'string') {
                init.approvedAt = new Date(init.approvedAt);
            }
            if (typeof init.rejectedAt === 'string') {
                init.rejectedAt = new Date(init.rejectedAt);
            }
            Object.assign(this, init);
        }
    }

    // Se utiliza para verificar si el usuario esta ligado a la comunidad
    communityId?: number;
    loyaltyPlanId?: number;
    // Afiliación activa al plan buscado (para wallet links)
    loyaltyPlanCustomerId?: number;
    // Afiliación activa en OTRO plan con tier del mismo comercio
    affiliatedTierPlanId?: number;
    affiliatedTierPlanName?: string;
    affiliatedTierPlanCustomerId?: number;
    scratchId?: number;
    transactionPackageId?: number;

    approvedAt?: Date;

    rejectedAt?: Date;
}


export class CustomerFindResultModel {

    public constructor(init?: Partial<Pick<CustomerFindResultModel, keyof CustomerFindResultModel>>) {

        if (init) {
            if (typeof init.birthDate === 'string') {
                init.birthDate = new Date(init.birthDate);
            }
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.emailVerifiedAt === 'string') {
                init.emailVerifiedAt = new Date(init.emailVerifiedAt);
            }
            if (typeof init.phoneVerifiedAt === 'string') {
                init.phoneVerifiedAt = new Date(init.phoneVerifiedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    name: string;
    lastName: string;

    email: string;
    emailVerifiedAt?: Date;

    phoneCountry: string;
    phone: string;
    phoneVerifiedAt?: Date;

    birthDate?: Date;
    province?: number;

    isActive: boolean;
    disabledType: DisabledType;

    createdAt: Date;


    get isPending(): boolean {

        if (this.id) {
            // Si no tiene fecha de cumpleaños ni provincia o esta en estado de preregister
            if ((!this.birthDate && !(this.province > 0)) || this.disabledType == DisabledType.Preregister) {
                return true;
            }
        }
        return false;
    }
}

export class CustomerGiveawaysModel {

    public constructor(init?: Partial<Pick<CustomerGiveawaysModel, keyof CustomerGiveawaysModel>>) {

        if (init) {
            if (typeof init.emailVerifiedAt === 'string') {
                init.emailVerifiedAt = new Date(init.emailVerifiedAt);
            }
            if (typeof init.phoneVerifiedAt === 'string') {
                init.phoneVerifiedAt = new Date(init.phoneVerifiedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    logoURL: string;

    name: string;
    lastName: string;
    email: string;
    emailVerifiedAt: Date;

    phoneCountry: string;
    phone: string;
    phoneVerifiedAt: Date;

    province = 0;
    canton = 0;

    // Se utiliza para verificar si el usuario esta ligado a la comunidad
    communityId?: number;
    scratchId?: number;

    approvedAt?: Date;

    rejectedAt?: Date;

    giveaways: CustomerGiveawayModel[];
}

export class CustomerGiveawayModel {

    public constructor(init?: Partial<Pick<CustomerGiveawayModel, keyof CustomerGiveawayModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    customerId: number;
    scratchId: number;

    productType: GiveawayProductType.Coupons;

    productId: number;
    productName: string;
    createdAt: Date;

}

export class CustomerGiveawayRegisterModel {

    public constructor(init?: Partial<Pick<CustomerGiveawayRegisterModel, keyof CustomerGiveawayRegisterModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    customerId: number;
    scratchId: number;

    type: GiveawayType;
    productType: GiveawayProductType.Coupons;

    productId: number;
    productName: string;
    deleteFromEnv: boolean;

    transactionPackageId: number;
    loyaltyPlanCustomerStickerId: number;

    uniqueLinkCode: string = null;

}

export class NewCustomerAccessTokenModel {

    public constructor(init?: Partial<Pick<NewCustomerAccessTokenModel, keyof NewCustomerAccessTokenModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    appType:  AppType;

    email: string;
    phoneCountry: string;
    phone: string;
}